import React, { useEffect } from "react";
import { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Button, Table, Card, Col, Form, Row } from "react-bootstrap";
import { IconPlus } from "@tabler/icons-react";
import useDebounce from "../../hooks/useDebounce";
import usePostRequest from "../../hooks/usePostRequest";
import { API_ENDPOINTS } from "../../constant/_constant";
import DynamicPagination from "../../components/DynamicPagination ";
import moment from "moment";
import { useFormContext, useFieldArray, get } from "react-hook-form";
import { toast } from "react-toastify";
function SkuSearchPopUp({
  show,
  setShow,
  setSearchProps,
  onAddSku,
  searchProps,
  setCardSearch,
  cardSearch,
  calculateCosts,
  updateTextArea,
}) {
  const [page, setPage] = useState(1);

  const [limit, setLimit] = useState(10);

  const [fetchedData, setFetchedData] = useState(null);

  const [searchDebounce, setSearchDebounce] = useState({
    searchSku: "",
    productName: "",
    searchDescription: "",
    searchVendor: "",
    contract_type: "",
  });

  const {
    getValues,
    register,
    watch,
    control,
    formState: { errors },
    setValue,
  } = useFormContext();

  useEffect(() => {
    if (searchProps) {
      setSearchDebounce({
        searchSku: searchProps.searchSku || "",
        productName: searchProps.productName || "",
        searchDescription: searchProps.searchDescription || "",
        searchVendor: searchProps.searchVendor || "",
        contract_type: searchProps.ContractName || "",
      });
    }
  }, [searchProps]);

  const handleAddClick = (product) => {
    const cardsss = getValues("cards");
    const firstCardType = getValues("productType");
    const incomingType = product?.type;
    const isFirstCard = searchProps.indexIs === 0;
    if (isFirstCard) {
      setValue("productType", { incomingType });
    } else {
      if (firstCardType && incomingType !== firstCardType?.incomingType) {
        toast.error(
          `All kit products must be of the same type. First item is "${firstCardType?.incomingType}".`
        );
        return;
      }
    }

    console.log("cardsss", cardsss);
    console.log("product", product);

    // const costValue =
    //   Number(product?.aspetto_price) === 0
    //     ? product?.customer_price
    //     : product?.aspetto_price;

    const costValueCustomer =
      Number(product?.customer_price) === 0
        ? product?.aspetto_price
        : product?.customer_price;

    if (searchProps.indexIs !== undefined) {
      setValue(
        `cards[${searchProps.indexIs}].vendorPartner`,
        product?.Vendor?.display_name,
        { shouldValidate: true }
      );
      setValue(`cards[${searchProps.indexIs}].skuIdUnique`, product?.sku_id, {
        shouldValidate: true,
      });
      setValue(`cards[${searchProps.indexIs}].productName`, product?.name, {
        shouldValidate: true,
      });
      setValue(
        `cards[${searchProps.indexIs}].skuId`,
        product?.sku_display_name,
        {
          shouldValidate: true,
        }
      );
      setValue(
        `cards[${searchProps.indexIs}].skuDescription`,
        product?.description,
        { shouldValidate: true }
      );

      if (updateTextArea && searchProps.indexIs !== undefined) {
        updateTextArea(searchProps.indexIs, product?.description);
      }
      setValue(`cards[${searchProps.indexIs}].um`, product?.uoi ?? "EA", {
        shouldValidate: true,
      });
      setValue(`cards[${searchProps.indexIs}].qty`, 1);
      setValue(`cards[${searchProps.indexIs}].cost`, product?.aspetto_price, {
        shouldValidate: true,
      });
      setValue(
        `cards[${searchProps.indexIs}].customerCost`,
        costValueCustomer,
        { shouldValidate: true }
      );
      // setValue(
      //   `cards[${searchProps.indexIs}].margin`,
      //   product?.margin_percent,
      //   { shouldValidate: true }
      // );

      const updatedCardSearch = [...cardSearch];
      updatedCardSearch[searchProps.indexIs] = {
        ...updatedCardSearch[searchProps.indexIs],
        showSuggestions: false,
      };
      setCardSearch(updatedCardSearch);
      calculateCosts();

      if (
        !searchProps.searchSku &&
        !searchProps.productName &&
        !searchProps.searchDescription &&
        !searchProps.searchVendor
      ) {
        // console.log("first");
        const updatedCards = getValues("cards");
        const nextBlankIndex = updatedCards.findIndex(
          (card) => !card.skuIdUnique && !card.cost && !card.skuDescription
        );
        setSearchProps({
          searchSku: "",
          productName: "",
          searchDescription: "",
          searchVendor: "",
          ContractName: searchProps.ContractName
            ? searchProps.ContractName
            : "",
          indexIs: nextBlankIndex !== -1 ? nextBlankIndex : undefined,
        });
      }

      const updatedCards = getValues("cards");
    } else {
      onAddSku(product);
      //calculateCosts()
    }
    toast.success(
      `Added Successfully Product ${product.sku_display_name} is added successfully`
    );
  };

  const handleSKUSearch = (e) => {
    setSearchDebounce((prevState) => ({
      ...prevState,
      searchSku: e.target.value,
    }));
    setPage(1);
  };
  const handleDescriptionSearch = (e) => {
    setSearchDebounce((prevState) => ({
      ...prevState,
      searchDescription: e.target.value,
    }));
  };

  const handleContractSearch = (e) => {
    setSearchDebounce((prevState) => ({
      ...prevState,
      contract_type: e.target.value,
    }));
  };

  const handleVendorSearch = (e) => {
    setSearchDebounce((prevState) => ({
      ...prevState,
      searchVendor: e.target.value,
    }));
  };

  const handleProductSearch = (e) => {
    setSearchDebounce((prevState) => ({
      ...prevState,
      productName: e.target.value,
    }));
  };

  const handlePageChange = (nextPage) => {
    setPage(nextPage);
  };

  const handleLimitChange = (selectedLimit) => {
    setLimit(selectedLimit);
  };

  const { debounceSearch } = useDebounce(searchDebounce);

  const { postData: fetchProductSearch, data } = usePostRequest(
    API_ENDPOINTS.PRODUCT_SUGGETION
  );

  useEffect(() => {
    fetchProductSearch({
      page,
      limit,
      type: "kit-products",
      module_type: "RFQ",
      product_name:
        searchDebounce?.productName?.length > 0
          ? searchDebounce?.productName
          : undefined,
      sku:
        searchDebounce?.searchSku?.length > 0
          ? searchDebounce?.searchSku
          : undefined,
      vendor:
        searchDebounce?.searchVendor?.length > 0
          ? searchDebounce?.searchVendor
          : undefined,
      description:
        searchDebounce?.searchDescription?.length > 0
          ? searchDebounce?.searchDescription
          : undefined,
      contract_type:
        searchDebounce?.contract_type?.length > 0
          ? searchDebounce?.contract_type
          : undefined,
    });
  }, [page, limit, searchDebounce]);

  useEffect(() => {
    if (data && data.data) {
      setFetchedData(data);
    }
  }, [data]);

  const handleCloseModal = () => {
    setShow(false);
    setSearchDebounce({
      searchSku: "",
      searchDescription: "",
      productName: "",
      searchVendor: "",
      contract_type: "",
    });
    setFetchedData(null);
  };

  return (
    <>
      <Modal
        scrollable={true}
        show={show}
        onHide={handleCloseModal}
        className="skusearch"
        dialogClassName="modal-90vw"
        aria-labelledby="example-custom-modal-styling-title"
      >
        <Modal.Header closeButton>
          <Row className="w-100">
            <Col className="mb-3">
              <Form.Control
                type="text"
                placeholder="Search Vendor"
                required
                name="name"
                autoComplete="off"
                value={searchDebounce.searchVendor}
                onChange={handleVendorSearch}
              />
            </Col>
            <Col className="mb-3">
              <Form.Control
                type="text"
                placeholder="Search Product Name"
                required
                name="name"
                autoComplete="off"
                value={searchDebounce.productName}
                onChange={handleProductSearch}
              />
            </Col>
            <Col className="mb-3">
              <Form.Control
                type="text"
                placeholder="Search By SKU ID"
                required
                name="name"
                autoComplete="off"
                value={searchDebounce.searchSku}
                onChange={handleSKUSearch}
              />
            </Col>
            <Col className="mb-3">
              <Form.Control
                type="text"
                placeholder="Search By Description"
                required
                name="name"
                autoComplete="off"
                value={searchDebounce.searchDescription}
                onChange={handleDescriptionSearch}
              />
            </Col>
            <Col className="mb-3">
              <Form.Control
                type="text"
                placeholder="Search By Contract Vehicle "
                required
                name="name"
                autoComplete="off"
                value={searchDebounce.contract_type}
                onChange={handleContractSearch}
              />
            </Col>
          </Row>
        </Modal.Header>
        <Modal.Body>
          <div className="table-responsive">
            <Table>
              <thead responsive>
                <tr>
                  <th>QUICK ADD</th>
                  <th className="text-center">VENDOR</th>
                  <th className="text-center">PRODUCT NAME</th>
                  <th className="text-center">SKU ID</th>
                  <th className="text-center">DESCRIPTION</th>
                  <th className="text-center">COST</th>
                </tr>
              </thead>
              <tbody>
                {fetchedData &&
                  fetchedData?.data?.map((product, index) => {
                    return (
                      <tr key={index}>
                        <td>
                          <span
                            onClick={() => handleAddClick(product)}
                            className="avatar bg-green-lt"
                          >
                            <IconPlus />
                          </span>
                        </td>
                        <td className="text-center">
                          {product?.Vendor?.display_name}
                        </td>
                        <td className="text-center">{product?.name}</td>
                        <td className="text-center">
                          {product?.sku_display_name}
                        </td>
                        <td className="text-center">
                          {product?.description?.length > 100
                            ? product.description.slice(0, 100) + "..."
                            : product.description}
                        </td>
                        <td className="text-center">
                          {product?.aspetto_price}
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </Table>
          </div>
          {data?.data?.length > 0 && (
            <DynamicPagination
              totalPages={data?.pagination?.totalPages}
              currentPage={page}
              onPageChange={handlePageChange}
              limitPerPage={limit}
              onLimitChange={handleLimitChange}
            />
          )}
        </Modal.Body>
      </Modal>
    </>
  );
}

export default SkuSearchPopUp;
